//Constants for status code
export const GLOBAL_STATUS = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  BAD_REQUEST: 400,
};

//Constants for screen Ids
export const SCREEN_IDS = {
  GENERIC: 0,
  BRANDS: 1,
  BRANDS_LOCATIONS: 2,
  GROUP: 3,
};

export const SURVEY_INTERACTIONS_TYPE_ENUM = {
  SURVEY_SENT: 1,
  SURVEY_ACCESS: 2,
  SURVEY_NEXT_QUESTION: 3,
  SURVEY_SUBMISSION: 4,
  GOOGLE_REVIEW: 5,
  SURVEY_ALREADY_SUBMITTED: 6,
  SURVEY_LINK_EXPIRED: 7,
  RECEIVED_GOOGLE_LINK: 8,
  NPS_GOOGLE_REVIEW: 9,
};
